import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import swal from 'sweetalert2';
import { Lightbox } from 'ngx-lightbox';
import { ValidationService } from 'src/app/service/validation.service';
import Speech from 'speak-tts';
import { UploadService } from 'src/app/service/upload.service';
@Component({
  selector: 'app-preview-question',
  templateUrl: './preview-question.component.html',
  styleUrls: ['./preview-question.component.scss']
})
export class PreviewQuestionComponent implements OnInit {

  speech = new Speech(); // will throw an exception if not browser supported

  @Input('question') public question: any = {};

  original_answers = [];
  original_answers_ids = [];
  selected_answers_ids = [];
  selected_answer_id = null;
  selected_options = [];
  typedAnswer: any = null;
  showAnswer: boolean = false;
  // question: any = {};

  constructor(
    public uploadService: UploadService,
    public _lightbox: Lightbox,
    public validationService: ValidationService
  ) { }

  ngOnInit() {
  }

  speechConfig() {
    if (this.speech.hasBrowserSupport()) {
      console.log('speech synthesis supported');
    }
    this.speech
      .init()
      .then(data => {
        console.log('Speech is ready, voices are available', data);
      })
      .catch(e => {
        console.error('An error occured while initializing : ', e);
      });
  }

  readSentance(sentance) {
    this.speech
      .speak({
        text: sentance
      })
      .then(() => {
        console.log('Success !');
      })
      .catch(e => {
        console.error('An error occurred :', e);
      });
  }

  option_selection(option) {
    if (this.showAnswer) {
      return;
    }
    if (this.question.answerCount === 'S') {
      this.selected_answer_id = option.id
      return
    }
    let index = this.selected_answers_ids.indexOf(option.id)
    if (index > -1) {
      this.selected_answers_ids.splice(index, 1)
    } else {
      this.selected_answers_ids.push(option.id)
    }
  }

  validateAnswers(question) {
    this.original_answers = [];
    this.original_answers_ids = [];
    if (this.question.answerType == 'M') {
      this.question.options.forEach(element => {
        if (element.isAnswer == true) {
          this.original_answers.push(element);
          this.original_answers_ids.push(element.id);
        }
      });
    }
    if (this.typedAnswer === null && this.selected_answer_id === null && this.selected_answers_ids.length === 0) {
      this.warningAlert(question.answerType == "T" ? "Kindly Type your answer" : "Kindly select atleast one option")
      return
    }

    if (this.question.answerType === "T") {
      if (this.validationService.text_answer_validation(this.question.textAnswer, this.typedAnswer)) {
        this.successAlert("Correct Answer!");
      } else {
        this.errorAlert("text", this.typedAnswer);
      }
      return;
    }

    if (this.question.answerType === "M" && this.question.answerCount === 'S') {
      if (this.validationService.single_option_validation(this.original_answers_ids, this.selected_answer_id)) {
        this.successAlert("Correct Answer!");
      } else {
        this.errorAlert("options", [this.selected_answer_id]);
      }
    } else if (this.question.answerType === "M" && this.question.answerCount === 'M') {
      if (this.validationService.multiple_option_validation(this.original_answers_ids, this.selected_answers_ids)) {
        this.successAlert("Correct Answer!");
      } else {
        this.errorAlert("options", this.selected_answers_ids);
      }
    }
  }

  successAlert(message) {
    swal({
      title: message,
      type: 'success',
      timer: 2000,
      showConfirmButton: false,
      showCancelButton: false
    }).then(willDelete => { });
  }

  warningAlert(message) {
    swal({
      title: message,
      type: 'warning',
      timer: 2000,
      showConfirmButton: false,
      showCancelButton: false
    }).then(willDelete => { });
  }

  errorAlert(type, options) {
    this.selected_options = [];
    if (type === "options") {
      this.question.options.forEach(element => {
        if (options.indexOf(element.id) > -1) {
          this.selected_options.push(element);
        }
      });
    }
    swal({
      title: "Oops!",
      text: "see the answer and learn it.",
      type: 'error',
    })
      .then((willDelete) => {
        this.showAnswer = true
      });
  }

  open(image_path): void {
    var _albums = [];
    const album = {
      src: image_path,
      caption: '',
      thumb: image_path
    };
    _albums.push(album);
    // open lightbox
    this._lightbox.open(_albums, 0);
  }

}
